export function appendOrdinal(n) {
    return `${n}${getOrdinal(n)}`;
}

export function getOrdinal(n) {
    const ones = n % 10;
    const tensAndOnes = n % 100;

    if (ones === 1 && tensAndOnes !== 11) {
        return "st";
    } else if (ones === 2 && tensAndOnes !== 12) {
        return "nd";
    } else if (ones === 3 && tensAndOnes !== 13) {
        return "rd";
    }

    return "th";
}
